// Read-only status chip component

import React from 'react'
import { Chip, Typography } from '@mui/material'

interface StatusChipProps {
  status: string | undefined
  getColor: (s: any) => 'success' | 'info' | 'error' | 'warning' | 'secondary' | 'default'
  size?: 'small' | 'medium'
}

const StatusChip: React.FC<StatusChipProps> = ({ status, getColor, size = 'small' }) => {
  if (!status) {
    return <Typography variant={size === 'medium' ? 'body1' : 'body2'} color="text.secondary" sx={{ fontSize: size === 'medium' ? '0.95rem' : undefined }}>-</Typography>
  }

  return (
    <Chip
      label={status}
      size={size}
      color={getColor(status)}
      variant="filled"
      sx={{
        height: size === 'medium' ? 28 : 22,
        fontSize: size === 'medium' ? '0.85rem' : undefined
      }}
    />
  )
}

export default StatusChip
